export enum RideUpdateEventsEnum {
  REACHED_DESTINATION = "REACHED_DESTINATION",
  PAYMENT_COMPLETED = "PAYMENT_COMPLETED",
  RIDE_CANCELED_BY_RIDER = "RIDE_CANCELED_BY_RIDER",
  RIDE_CANCELED_BY_RIDER_BEFORE_ACCEPT = "RIDE_CANCELED_BY_RIDER_BEFORE_ACCEPT",
  RIDE_CANCELED_BY_DRIVER = "RIDE_CANCELED_BY_DRIVER",
  NEW_MESSAGE_FROM_DRIVER = "NEW_MESSAGE_FROM_DRIVER",
  NEW_MESSAGE_FROM_RIDER = "NEW_MESSAGE_FROM_RIDER",
  DRIVER_SEEN_ALL_MESSAGE = "DRIVER_SEEN_ALL_MESSAGE",
  RIDER_SEEN_ALL_MESSAGE = "RIDER_SEEN_ALL_MESSAGE",
  COMPLETE_EXISTING_RIDE = "COMPLETE_EXISTING_RIDE",
  CANCEL_RIDE = "CANCEL_RIDE",
  RIDE_START_AFTER_CURRENT_RIDE_CONCLUSION = "RIDE_START_AFTER_CURRENT_RIDE_CONCLUSION",
  DRIVER_WALLET_BALANCE_INSUFICIENT = "DRIVER_WALLET_BALANCE_INSUFICIENT",
  VALID_OTP = "VALID_OTP",
  INVALID_OTP = "INVALID_OTP",
  RIDE_ALREADY_ACCEPTED = "ride-already-accepted",
  CANCEL_RIDE_SUGGEST = "cancel-ride-suggest",
  REQUEST_CANCEL_BY_RIDER = "REQUEST_CANCEL_BY_RIDER",
  REQUEST_CANCEL_BY_DRIVER = "REQUEST_CANCEL_BY_DRIVER",
  CONFIRM_CANCEL = "CONFIRM_CANCEL",
  REJECT_CANCEL = "REJECT_CANCEL",
  CANCEL_FEE_APPLIED = "CANCEL_FEE_APPLIED",
  DRIVER_LOCATION_MISSING = "DRIVER_LOCATION_MISSING",
  DISPUTE_OPENED = "DISPUTE_OPENED",
}
